/**
 * Format a date for display (date-only, YYYY-MM-DD). Handles null/undefined/invalid.
 */
export function formatDateOnly(value) {
  if (value == null || value === '') return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  // Use UTC methods so date-only values (expiration, license dates) are not shifted by timezone
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

const s = {
  // year: 31536000,
  // month: 2592000,
  // week: 604800,
  day: 86400,
  hour: 3600,
  minute: 60,
  second: 1
};

export const timeDiffWithSeconds = (dateFuture, dateNow) => {
  let d = Math.abs(dateFuture - dateNow) / 1000;
  const r = {};
  Object.keys(s).forEach((key) => {
    r[key] = Math.floor(d / s[key]);
    d -= r[key] * s[key];
  });
  return `${r.hour}:${r.minute}:${r.second}`;
};

export default function (dateFuture, dateNow) {
  let d = Math.abs(dateFuture - dateNow) / 1000;
  const r = {};
  Object.keys(s).forEach((key) => {
    r[key] = Math.floor(d / s[key]);
    d -= r[key] * s[key];
  });
  return `${r.day}:${r.hour}:${r.minute}`;
}
